import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export var getAllCookies = function getAllCookies() {
  return document.cookie.split(";").reduce(function (cookies, cookie) {
    var _cookie$split$map = cookie.split("=").map(function (c) {
      return c.trim();
    }),
        _cookie$split$map2 = _slicedToArray(_cookie$split$map, 2),
        name = _cookie$split$map2[0],
        value = _cookie$split$map2[1];

    cookies[name] = value;
    return cookies;
  }, {});
};